module.exports = __webpack_public_path__ + "static/media/blood.4fd1e65f.svg";